import { useQuery } from '@tanstack/react-query';
import { API_BASE } from './api-base';
import { apiFetch } from './api-client';
import { queryClient, queryKeys } from './query-client';

async function fetchSiteTimeZone(): Promise<string | null> {
  const res = await apiFetch(`${API_BASE}/api/site-time-zone`, { credentials: 'include' });
  if (!res.ok) throw new Error(`site-time-zone ${res.status}`);
  const data = (await res.json()) as { timeZone?: unknown } | null;
  return typeof data?.timeZone === 'string' && data.timeZone ? data.timeZone : null;
}

export function useSiteTimeZone() {
  return useQuery({ queryKey: queryKeys.siteTimeZone, queryFn: fetchSiteTimeZone });
}

/** Optimistic: the row shows the pick at once and falls back to the previous zone if the write fails. */
export async function saveSiteTimeZone(timeZone: string): Promise<boolean> {
  // A read still in flight would land the old zone over this pick.
  await queryClient.cancelQueries({ queryKey: queryKeys.siteTimeZone });
  const previous = queryClient.getQueryData<string | null>(queryKeys.siteTimeZone);
  queryClient.setQueryData(queryKeys.siteTimeZone, timeZone);
  try {
    const res = await apiFetch(`${API_BASE}/api/site-time-zone`, {
      method: 'POST',
      credentials: 'include',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({ timeZone }),
    });
    if (res.ok) return true;
  } catch {
    // falls through to the rollback
  }
  queryClient.setQueryData(queryKeys.siteTimeZone, previous ?? null);
  return false;
}
